// Slice meant for globally storing everything that goes into the MongoDB
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

// Define the TS type for the counter slice's state
export interface SurveyState {
    qualtrics_id: string,
    control_condition: number
  }
  
  // Define the initial value for the slice state
  const initialState: SurveyState = {
    qualtrics_id: 'initString',
    control_condition: 1
  }
  
  // Slices contain Redux reducer logic for updating state, and
  // generate actions that can be dispatched to trigger those updates.
  export const surveySlice = createSlice({
    name: 'survey',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
      // Use the PayloadAction type to declare the contents of `action.payload`
      setID: (state, action: PayloadAction<string>) => {
        state.qualtrics_id = action.payload
      },
      setCondition: (state, action: PayloadAction<number>) => {
        state.control_condition = action.payload
      }
    }
  })
  
  // Export the generated action creators for use in components
  export const { setID, setCondition } = surveySlice.actions
  
  // Export the slice reducer for use in the store configuration
  export default surveySlice.reducer